import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            id: '',
            name: '',
            reg: '',
            filter: '',
            openAddCost: false,
            costToEdit: null,
            vehiclesCosts: [],
            types: [],
        }
    },
    computed: {
        filteredUsers() {
            return this.vehiclesCosts.filter(item => {
                return item.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    this.getType(item.type).toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    item.description.toLowerCase().indexOf(this.filter.toLowerCase()) > -1;
            })
        }
    },
    methods: {
        getVehiclesCosts: getVehiclesCosts,
        getType: getType,
        formatDate: formatDate,
        deleteVehicleCost: deleteVehicleCost,
        editVehicleCost: editVehicleCost,
        keymonitor: keymonitor,
        clickSearch: clickSearch,
        openAddUserModal: openAddUserModal,
    },
    created(){
        let _self = this;
        this.$topnavbar.$on('closeAddVehicleCosts', () => {
            _self.openAddCost = false;
        });

        this.$topnavbar.$on('successAddVehicleCosts', () => {
            _self.openAddCost = false;
            swal('Uspešno', 'Uspešno dodat trošak', 'success')
            _self.getVehiclesCosts();
        });

        this.$topnavbar.$on('successEditVehicleCosts', () => {
            _self.openAddCost = false;
            swal('Uspešno', 'Uspešno izmenjen trošak', 'success')
            _self.getVehiclesCosts();
        });

    },

    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/login');
            return;
        }
        this.id = this.$route.query.id;
        this.name = this.$route.query.name;
        this.reg = this.$route.query.reg;
        this.getVehiclesCosts()
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                // this.pagination.page = 1;
                // this.getDrivers();
            }
        },
    }
}

function editVehicleCost(vehicle) {
    this.costToEdit = vehicle;
    this.openAddCost = true;
}

function openAddUserModal() {
    this.costToEdit = null;
    this.openAddCost = true;
}

function clickSearch() {
    // this.pagination.page = 1;
    // this.getDrivers()
}

function getVehiclesCosts() {
    var _self = this;
    AdminApiService.getVehiclesCosts(_self.id)
        .then((response) => {
            _self.vehiclesCosts = response.data;
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}


function keymonitor(event) {
    if (event.key === 'Enter') {
        this.getVehiclesCosts();
    }
}

function deleteVehicleCost(item) {
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da obrisete trošak " + _self.getType(item.type) + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$topnavbar.$emit('load');
        AdminApiService.deleteVehicleCost(_self.id, item.id )
            .then((response) => {
                swal('Uspešno', 'Uspešno ste obrisali trošak', 'success')
                _self.getVehiclesCosts();
            })
            .catch((error) => {
                swal('Greška', error.data.message, 'error')
            })
    });
}


function getType(type){
    switch (type) {
        case "SMALL_SERVICE": return "Mali servis";
        case "BIG_SERVICE": return "Veliki servis";
        case "REGISTRATION": return "Registracija";
        case "FIX": return "Popravka";
        case "OTHER": return "Ostalo";
        default: return ""
    }
}

function formatDate(date) {
    return this.$moment(new Date(date )).format('DD-MM-YYYY - HH:mm')
}


// WEBPACK FOOTER //
// ./src/components/Vehicle/VehicleCosts.js